// app bundle loaded, call the callback
window.queue.appLoaded()
